import React, { useContext } from "react";
import "./home-style.css";
import LanguageContext from "../../context/LanguageContext";

const jsonDataEn = require("./data/home-data-en.json");
const jsonDataFr = require("./data/home-data-fr.json");

const Testimonial = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data.testimonial : jsonDataFr.data.testimonial;
  return (
    <section className="testimonial">
      <div className="testimonial__inner">
        {/* LEFT: Photo */}
        <div className="testimonial__media">
          <div className="photo-frame">
            <img src="/assets/home/Nico Vlachos.jpg" /* replace with your image */ alt="Nico Vlachos, Gym Owner" className="photo" />
          </div>
        </div>

        {/* RIGHT: Content */}
        <div className="testimonial__content">
          <div className="stars" aria-label="5 out of 5 stars">
            ★★★★★
          </div>

          <blockquote className="quote">{data.comment} </blockquote>

          <div className="meta">
            <div className="person">
              <div className="name">Nico Vlachos</div>
              <div className="role">{data.position}</div>
            </div>

            <div className="pipe" aria-hidden="true" />

            <img src="/assets/bigdaddyfitness/bigdaddyfitness-logo.png" /* your client logo */ alt="Big Daddy Fitness" className="client-logo" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
